import { DynamicImage, enLoading } from 'components/Image';
import { GiocataCorsa } from 'lib/api/virtual/virtualTemplateAvvenimentoApi';
import React from 'react';
import { Stato } from 'features/ippica/types';
import { VirtualScommesseEsitoTipoBox } from 'features/ippica/components/ippicaScommesseEsitoTipoBox/IppicaScommesseEsitoTipoBox';
import { VirtualScommesseEsitoTipoBoxChiuso } from 'features/ippica/components/ippicaScommesseEsitoTipoBoxChiuso/IppicaScommesseEsitoTipoBoxChiuso';
import { VirtualScommesseTablePosition } from '../virtualScommesseTablePosition';
import { WinnerChip } from 'components/winnerChip';
import { formatKey } from 'features/virtual/utils/functions';
import { isNotEmpty } from 'utility/functions';
import styles from './VirtualScommesseCorsaRow.module.scss';

export type VirtualScommesseCorsaRowProps = {
  nome: string;
  posizionePartenza: number;
  listaQuote: GiocataCorsa['listaQuote'];
  imageSrc?: string;
  posizioneFinale?: number;
  isWinner?: boolean;
  timestamp?: string;
  stato?: Stato;
  hasBorderBottom?: boolean;
  children?: React.ReactNode;
  keyAvvenimento?: string;
};

export const VirtualScommesseCorsaRow = ({ ...props }: VirtualScommesseCorsaRowProps) => {
  return (
    <div
      className={`${styles.container} ${props.hasBorderBottom ? styles.containerBorderBottom : ''} ${
        props.stato === Stato.Chiusa ? styles.quoteContainerResults : ''
      }`}
    >
      <VirtualScommesseTablePosition
        stato={props.stato === Stato.Aperta ? props.stato : Stato.Chiusa}
        posizionePartenza={props.posizionePartenza}
        posizioneFinale={props.posizioneFinale}
        containerClassName={`${styles.positionWrapper} ${
          props.stato === Stato.Chiusa ? styles.positionWrapperResults : ''
        }`}
      />
      <div className={styles.main}>
        {isNotEmpty(props.imageSrc) && (
          <span className={styles.imageContainer}>
            <DynamicImage
              className={styles.image}
              src={`${props.imageSrc}`}
              alt={props?.nome ?? ''}
              title={props?.nome ?? ''}
              fill
              loading={enLoading.lazy}
              decoding="async"
            />
          </span>
        )}
        <span className={styles.name}>{props.nome}</span>
        {props.isWinner && <WinnerChip containerClassName={styles.chipContainer} chipClassName={styles.chip} />}
      </div>

      <div className={`${styles.quoteList}`}>
        {props.listaQuote.map((singleQuota, index) => {
          return (
            <div key={`${singleQuota}-${index}`} className={styles.quoteContainer}>
              {props.stato === Stato.Aperta ? (
                <VirtualScommesseEsitoTipoBox
                  label={singleQuota.label}
                  quota={singleQuota.quota}
                  scommessaKey={
                    props.keyAvvenimento
                      ? formatKey([
                          props.keyAvvenimento,
                          singleQuota.codTipoScommessa.toString(),
                          props.posizionePartenza.toString(),
                        ])
                      : ''
                  }
                />
              ) : (
                <VirtualScommesseEsitoTipoBoxChiuso
                  label={singleQuota.label}
                  quota={singleQuota.quota}
                  isSmall={false}
                  containerClassName={`${styles.quota}`}
                />
              )}
            </div>
          );
        })}
      </div>
      {props.children && props.children}
    </div>
  );
};
